/**
 * StatsBar — live counters under the hero. Reads /api/grading/stats/public,
 * which is cached server-side for 60 s.
 */
import React from 'react';

export default function StatsBar({ stats }) {
  const items = [
    { label: 'Cards graded',         value: stats?.totalReports },
    { label: 'Graded this week',     value: stats?.last7Days },
    { label: 'Estimated 9.5+',       value: stats?.gemMintCount },
    { label: 'Real-grade comparisons', value: stats?.calibrationSamples },
  ];
  return (
    <section className="gp-section gp-section--tight">
      <div className="gp-stats">
        {items.map((it, i) => (
          <div key={i} className="gp-stat">
            <div className="gp-stat__value">{format(it.value)}</div>
            <div className="gp-stat__label">{it.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

function format(n) {
  if (!Number.isFinite(n)) return '—';
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + 'M';
  if (n >= 1_000)     return (n / 1_000).toFixed(1) + 'k';
  return String(n);
}
